const palette = [
  {
    color: 'rose',
    backgroundColor: 'tw-bg-rose-100',
    borderColor: 'tw-border-rose-500',
    hoverShadowColor: 'hover:tw-shadow-rose-500/50',
  },
  {
    color: 'indigo',
    backgroundColor: 'tw-bg-indigo-100',
    borderColor: 'tw-border-indigo-500',
    hoverShadowColor: 'hover:tw-shadow-indigo-500/50',
  },
  {
    color: 'sky',
    backgroundColor: 'tw-bg-sky-100',
    borderColor: 'tw-border-sky-500',
    hoverShadowColor: 'hover:tw-shadow-sky-500/50',
  },
  {
    color: 'emerald',
    backgroundColor: 'tw-bg-emerald-100',
    borderColor: 'tw-border-emerald-500',
    hoverShadowColor: 'hover:tw-shadow-emerald-500/50',
  },
  {
    color: 'amber',
    backgroundColor: 'tw-bg-amber-100',
    borderColor: 'tw-border-amber-500',
    hoverShadowColor: 'hover:tw-shadow-amber-500/50',
  },
  {
    color: 'stone',
    backgroundColor: 'tw-bg-stone-100',
    borderColor: 'tw-border-stone-500',
    hoverShadowColor: 'hover:tw-shadow-stone-500/50',
  },
  {
    color: 'pink',
    backgroundColor: 'tw-bg-pink-100',
    borderColor: 'tw-border-pink-500',
    hoverShadowColor: 'hover:tw-shadow-pink-500/50',
  },
  {
    color: 'violet',
    backgroundColor: 'tw-bg-violet-100',
    borderColor: 'tw-border-violet-500',
    hoverShadowColor: 'hover:tw-shadow-violet-500/50',
  },
  {
    color: 'blue',
    backgroundColor: 'tw-bg-blue-100',
    borderColor: 'tw-border-blue-500',
    hoverShadowColor: 'hover:tw-shadow-blue-500/50',
  },
  {
    color: 'cyan',
    backgroundColor: 'tw-bg-cyan-100',
    borderColor: 'tw-border-cyan-500',
    hoverShadowColor: 'hover:tw-shadow-cyan-500/50',
  },
  {
    color: 'red',
    backgroundColor: 'tw-bg-red-100',
    borderColor: 'tw-border-red-500',
    hoverShadowColor: 'hover:tw-shadow-red-500/50',
  },
  {
    color: 'lime',
    backgroundColor: 'tw-bg-lime-100',
    borderColor: 'tw-border-lime-500',
    hoverShadowColor: 'hover:tw-shadow-lime-500/50',
  },
  {
    color: 'orange',
    backgroundColor: 'tw-bg-orange-100',
    borderColor: 'tw-border-orange-500',
    hoverShadowColor: 'hover:tw-shadow-orange-500/50',
  },
  {
    color: 'zinc',
    backgroundColor: 'tw-bg-zinc-100',
    borderColor: 'tw-border-zinc-500',
    hoverShadowColor: 'hover:tw-shadow-zinc-500/50',
  },
];

export default palette;
